document.addEventListener('DOMContentLoaded', function() {
    // Use event delegation
    document.body.addEventListener('click', function(event) {
        if (event.target.classList.contains('ajax-add-to-cart')) {
            var variantId = event.target.getAttribute('data-variant-id');
          console.log(variantId+'--');
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: 1
                    }]
                })
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                console.log('Item added to cart:', data);
                // Optionally update cart drawer content here
              $("#mycartdrawer").load(location.href + " #CartDrawer");
            })
            .catch((error) => {
                console.error('Error adding to cart:', error);
            });
        }
    });
});